import React from "react";
import { Layout } from "antd";

import { BitmakerAPIClient } from "../../services/BitmakerApp";
import { ClientsListData } from "../../bitmaker/schemas/Clients";
import { useNavigate } from "react-router-dom";

const { Content } = Layout;

export const ClientsDashboard: React.FC = () => {
  const [clientsData, setClientsData] = React.useState<Array<ClientsListData>>(
    []
  );
  const navigate = useNavigate();

  const fetchClients = async () => {
    BitmakerAPIClient.get("/billing/clients", null, (response: any) => {
      setClientsData(response.data);
    });
  };

  React.useEffect(() => {
    fetchClients();
  }, []);

  const handleClientClick = (id: number, name: string) => {
    const path = `/invoices/${id}?name=${encodeURIComponent(name)}`;
    navigate(path);
  };

  return (
    <Layout>
      <Content
        style={{ display: "flex", justifyContent: "center", padding: "20px" }}
      >
        <ul
          style={{
            listStyleType: "none",
            padding: 0,
            cursor: "pointer",
            fontSize: "20px",
            textAlign: "center",
          }}
        >
          {clientsData.map((client) => (
            <li
              key={client.id}
              onClick={() => handleClientClick(client.id, client.name)}
            >
              {client.name}
            </li>
          ))}
        </ul>
      </Content>
    </Layout>
  );
};

export default ClientsDashboard;
